function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapMutations } from 'vuex';
import { filterMixin } from '@/mixins/filter_mixin';
import UseCasesService from '@/apps/attributes/services/use_cases_service';
import AddAttributeGroupComponent from '@/apps/attributes/components/AddAttributeGroupComponent';
export default {
  name: 'SelectedAttributesPage',
  components: {
    AddAttributeGroupComponent: AddAttributeGroupComponent
  },
  mixins: [filterMixin],
  data: function data() {
    return {
      filterNotNull: 0,
      items: [],
      categories: [],
      dataTypes: [],
      partitionsByTable: {},
      keyTable: 1,
      page: 1,
      pageCount: 0,
      itemsPerPage: 25,
      pagination: {
        current: 1,
        limit: 25,
        total: 0
      },
      slider: {
        min: 0,
        max: 100,
        range: [0, 100]
      },
      filtro: {
        tipo_dato: [],
        categoria: [],
        sin_valor: true
      },
      search: '',
      DIALOG_ADD_GROUP_ATTRIBUTE: 'DIALOG_ADD_GROUP_ATTRIBUTE',
      valid: true
    };
  },
  created: function created() {
    this.initData();
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapMutations('app', ['setShowLoading'])), mapMutations('attribute', ['setAttributes'])), {}, {
    onChangePartitions: function onChangePartitions(table) {
      var _this = this;
      this.items.forEach(function (element, index) {
        if (element.tabla === table) {
          var field = _this.partitionsByTable[table].field;
          var selection = _this.partitionsByTable[table].selection;
          _this.items[index].filters = {};
          _this.items[index].filters["".concat(field)] = selection;
        }
      });
    },
    initData: function initData() {
      var _this2 = this;
      this.setShowLoading(true);
      this.items = this.attributes;
      // Se agrupa por categorías y por tipo de dato, para filtrar
      this.categories = _toConsumableArray(new Set(this.items.map(function (item) {
        return item.categoria;
      })));
      this.dataTypes = _toConsumableArray(new Set(this.items.map(function (item) {
        return item.tipo_dato;
      })));

      // Definimos un arreglo con las promesas que hacen el request de las particiones de las tablas
      var partitionRequests = [];
      var periodsByTable = {};
      this.categories.forEach(function (category) {
        var itemsFilter = _this2.items.filter(function (item) {
          return item.categoria === category;
        });
        var item = itemsFilter.shift();
        var projectId = item.proyecto;
        var datasetId = item.dataset;
        var tableId = item.tabla;
        var periods = item.filters;
        var request = UseCasesService.getTablePartitionField(projectId, datasetId, tableId);
        partitionRequests.push(request);
        if (periods !== undefined) {
          periodsByTable[tableId] = periods.process_date;
        }
      });
      Promise.all(partitionRequests).then(function (values) {
        values.forEach(function (value) {
          var data = value.data.partition_info;
          if (data.values !== null) {
            var periodos = [];
            value.data.partition_info.values.map(function (object) {
              var periodo = {
                id: object,
                name: object
              };
              periodos.push(periodo);
            });
            periodos.sort(_this2.dynamicSort('-id'));
            value.data.partition_info.values = periodos;
          }
          var table = data.table_id.split('.').pop();
          _this2.partitionsByTable[table] = data;
          // this.partitionsByTable[table].selection = []
          _this2.partitionsByTable[table].selection = periodsByTable[table];
        });
      }).finally(function () {
        _this2.keyTable = _this2.keyTable + 1;
        _this2.setShowLoading(false);
      });
    },
    saveAttributes: function saveAttributes() {
      this.attributes = this.items;
    },
    onStartRequest: function onStartRequest() {
      this.saveAttributes();
      this.$router.push('/attributes/sandbox/request');
    },
    removeItem: function removeItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.items.splice(this.editedIndex, 1);
    },
    changeFilter: function changeFilter() {
      var _this3 = this;
      this.items = this.attributes;
      if (this.filtro.sin_valor) {
        this.items = this.items.filter(function (item) {
          return item.no_nulo >= parseInt(_this3.slider.range[0]) && item.no_nulo <= parseInt(_this3.slider.range[1]) || item.no_nulo === -1;
        });
      } else {
        this.items = this.items.filter(function (item) {
          return item.no_nulo >= parseInt(_this3.slider.range[0]) && item.no_nulo <= parseInt(_this3.slider.range[1]);
        });
      }
      if (this.filtro.categoria.length > 0) {
        this.items = this.items.filter(function (item) {
          return _this3.filtro.categoria.includes(item.categoria);
        });
      }
      if (this.filtro.tipo_dato.length > 0) {
        this.items = this.items.filter(function (item) {
          return _this3.filtro.tipo_dato.includes(item.tipo_dato);
        });
      }
    },
    openDialog: function openDialog(modalName) {
      this.$refs[modalName].onOpen();
    },
    registerGroup: function registerGroup(modalName) {
      console.log('registerGroup', this.items);
      this.openDialog(modalName);
    },
    cleanSelection: function cleanSelection() {
      this.$refs["MODAL_CONFIRM_CLEAN_SELECTION"].onOpen();
    },
    onConfirmClean: function onConfirmClean(value) {
      if (value) {
        this.setAttributes([]);
        this.items = [];
        this.initData();
        this.$refs["MODAL_CONFIRM_CLEAN_SELECTION"].onClose();
      } else {
        this.$refs["MODAL_CONFIRM_CLEAN_SELECTION"].onClose();
      }
    },
    goToWizard: function goToWizard() {
      if (!this.$refs.form.validate()) {
        var _iterator = _createForOfIteratorHelper(this.$refs.form.$children),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var el = _step.value;
            console.log('el');
            console.log(el);
            if (el.valid === false) {
              el.focus();
              break;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        return;
      }
      this.onStartRequest();
      // this.$router.push('/attributes/sandbox/request')
    },
    dynamicSort: function dynamicSort(property) {
      var sortOrder = 1;
      if (property[0] === '-') {
        sortOrder = -1;
        property = property.substr(1);
      }
      return function (a, b) {
        // La siguiente línea funciona con cadenas y números, puedes personalizarla según tus necesidades
        var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
        return result * sortOrder;
      };
    }
  }),
  computed: _objectSpread(_objectSpread({}, mapState('attribute', ['attributes'])), {}, {
    headers: function headers() {
      return [{
        text: this.translate('table_selected_attributes.name'),
        value: 'nombre',
        align: 'start'
      }, {
        text: this.translate('table_selected_attributes.description'),
        value: 'descripcion',
        align: 'start'
      }, {
        text: this.translate('table_selected_attributes.data_type'),
        value: 'tipo_dato',
        align: 'start'
      }, {
        text: this.translate('table_selected_attributes.percentage'),
        value: 'no_nulo',
        align: 'end'
      }, {
        text: '',
        value: 'actions',
        align: 'center'
      }];
    },
    rules: function rules() {
      var _this4 = this;
      return {
        period: [function (v) {
          return v.length > 0 || _this4.translate('reglas.period');
        }]
      };
    }
  })
};